function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.88379 12C3.88379 16.6944 7.68937 20.5 12.3838 20.5C17.0782 20.5 20.8838 16.6944 20.8838 12C20.8838 7.30558 17.0782 3.5 12.3838 3.5C7.68937 3.5 3.88379 7.30558 3.88379 12ZM2.88379 12C2.88379 6.7533 7.13708 2.5 12.3838 2.5C17.6305 2.5 21.8838 6.7533 21.8838 12C21.8838 17.2467 17.6305 21.5 12.3838 21.5C7.13708 21.5 2.88379 17.2467 2.88379 12ZM12.3838 6.5C12.6599 6.5 12.8838 6.72386 12.8838 7V13C12.8838 13.2761 12.6599 13.5 12.3838 13.5C12.1076 13.5 11.8838 13.2761 11.8838 13V7C11.8838 6.72386 12.1076 6.5 12.3838 6.5ZM11.8838 17C11.8838 16.7239 12.1076 16.5 12.3838 16.5C12.6599 16.5 12.8838 16.7239 12.8838 17C12.8838 17.2761 12.6599 17.5 12.3838 17.5C12.1076 17.5 11.8838 17.2761 11.8838 17Z",
  fill: "#E61212"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.e3b475f2.svg";
export { ForwardRef as ReactComponent };